import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const ObjecionesSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    request
      .get("ListadoGestionesRealizadasComentario/Objeciones")
      .then((result) => {
        // Agregar la opción de "Consolidado" con id 0
        const objecionesOptions = [
          { value: 999, label: "Consolidado" }, 
          ...result.map((responsable) => ({
            value: responsable.id_objecion,
            label: capitalizePalabras(responsable.descripcion),
          })),
        ];
        setState(objecionesOptions);
      })
      .catch((error) => {
        console.error("Error obteniendo objeciones:", error);
      });
  }, []);

  return (
    <select className="select-objeciones" name={name} value={value} onChange={onChange}>
      {state.map((item) => (
        <option key={`objecion-${item.value}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
